import { ReactElement } from "react";
import Modify from "@shared/FormTemplates/Modify";
import ModifyForm from "./ModifyForm";
import updateItem from "@services/Clients/WhaleShark/fearGreed/updateItem";
import useGetDetailItem from "@hooks/Clients/WhaleShark/fearGreed/useGetFearGreed";
import validator from "@validators/Clients/WhaleShark/fearGreed/fearGreed.validate";
import formMapper from "@mappers/Clients/WhaleShark/fearGreed/UpdateFearGreed.mapper";

const ModifyItem = (): ReactElement => (
  <Modify
    CustomForm={ModifyForm}
    modifyHook={updateItem}
    detailHook={useGetDetailItem}
    validator={validator}
    formMapper={formMapper}
  />
);

export default ModifyItem;
